export default __webpack_public_path__ + "static/jamie@2x-17fd60d2c7ccf6a67f24d153b69abe2f.jpg";